// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3nO6v","containerItemsCenter":"Skeleton_containerItemsCenter__3ZS6n"};